module.exports = __webpack_public_path__ + "1ec3bd27170aa14566025cffb2efe9e1.png";